import { render, staticRenderFns } from "./BulkUpload.vue?vue&type=template&id=677d2244&scoped=true&"
import script from "./BulkUpload.vue?vue&type=script&lang=js&"
export * from "./BulkUpload.vue?vue&type=script&lang=js&"
import style0 from "./BulkUpload.vue?vue&type=style&index=0&id=677d2244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677d2244",
  null
  
)

export default component.exports